import { faAward, faFunnelDollar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RadioGroup } from "@headlessui/react";
import { SearchIcon } from "@heroicons/react/solid";
import React, { useState } from "react";
import { SideBarStates } from "../../../context/SidebarContext";
import { BasePanelComponent, Dropdown } from "./CommonComponents";

export function GradesPanel() {
  const [role, setRole] = useState<"instructor" | "student">("student");

  return (
    <BasePanelComponent openState={SideBarStates.Grades}>
      <BasePanelComponent.Header
        title="Grading and Submissions"
        iconName={faAward}
        content={
          <div className="flex">
            <FontAwesomeIcon
              icon={faFunnelDollar}
              size="lg"
              className="text-gray-400 mr-4"
            />
            <SearchIcon className="h-6 w-6 text-gray-400" aria-hidden="true" />
          </div>
        }
      ></BasePanelComponent.Header>
      <BasePanelComponent.Body className="w-screen max-w-md">
        <SelectRole role={role} setRole={setRole} />
        <Dropdown
          title={role === "instructor" ? `NEEDS GRADING` : "RECENTLY GRADED"}
          emptyText={
            role === "instructor" ? `Nothing to grade` : "No recent grades"
          }
        />
        <Dropdown
          title={role === "instructor" ? `NEEDS REVIEW` : "GRADE PENDING"}
          emptyText={
            role === "instructor" ? `Nothing to review` : "No pending grades"
          }
        />
        <Dropdown
          title="NON-GRADED SUBMISSIONS"
          emptyText="Nothing to review"
        />
        <Dropdown title="RECENTLY VIEWED" emptyText="Nothing has been viewed" />
      </BasePanelComponent.Body>
    </BasePanelComponent>
  );
}

function SelectRole({
  role,
  setRole,
}: {
  role: "instructor" | "student";
  setRole: React.Dispatch<React.SetStateAction<"instructor" | "student">>;
}) {
  return (
    <RadioGroup
      value={role}
      onChange={setRole}
      as="div"
      className="flex w-full"
    >
      <RadioGroup.Option
        value="instructor"
        className="flex flex-1 items-center justify-center"
      >
        {({ checked }) => (
          <div
            className={`w-full h-full text-center py-3 text-lg border-b border-r border-gray-300 ${
              checked ? "bg-teal-050" : "text-teal-600 bg-white"
            }`}
          >
            INSTRUCTOR
          </div>
        )}
      </RadioGroup.Option>
      <RadioGroup.Option
        value="student"
        className="flex flex-1 items-center justify-center border-b border-gray-300"
      >
        {({ checked }) => (
          <div
            className={`w-full h-full text-center py-3 text-lg ${
              checked ? "bg-teal-050" : "text-teal-600 bg-white"
            }`}
          >
            STUDENT
          </div>
        )}
      </RadioGroup.Option>
    </RadioGroup>
  );
}
